'use client';

import CloseIcon from '@/components/icons/Close';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export default function ExitButton() {
  const pathname = usePathname();
  const showCloseIcon = !pathname.includes('/quote');

  if (!showCloseIcon) {
    return null;
  }

  return (
    <Link
      href='/'
      aria-label='Go to homepage'
      className='hover:bg-sh-black/30 fixed top-[calc(var(--promo-banner-h,0px)+1rem)] right-5 flex rounded-full p-1'
    >
      <CloseIcon className='text-sh-black size-8 lg:size-12' />
    </Link>
  );
}
